import { APP_BASE_HREF } from "@angular/common";
import { Component, Inject, OnInit, OnDestroy } from "@angular/core";

@Component({
    selector: 'web-admin',
    templateUrl: 'web-admin.component.html',
    styleUrls: ['web-admin.component.css']
})

export class WebAdminComponent implements OnInit, OnDestroy {
    constructor(
        @Inject(APP_BASE_HREF) public baseHref: string) {
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }
}
